module.exports = __webpack_public_path__ + "static/media/future_01.3d2eff9f.png";